import { useMutation } from 'react-query';
import { QueryKeys } from 'shared/constants/entityTypes';
import { Projects } from 'shared/utils/api';
import { queryClient } from 'shared/utils/queryClient';

const entityName = QueryKeys.PROJECTS;

export function useProjectCreate() {
  const keysToInvalidate = [
    [entityName, 'list'],
    [entityName, 'options'],
  ];
  const mutationFn = (project) =>
    Projects.create(project).then((res) => res?.data);
  const { mutateAsync, ...mutationObject } = useMutation({
    mutationFn,
    onSuccess: () => {
      keysToInvalidate.forEach((k) => queryClient.invalidateQueries(k));
    },
  });

  return [mutateAsync, mutationObject];
}
